module.exports = __webpack_public_path__ + "static/media/contact_bg.6be829b7.png";